







import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Company from "../../models/company/Company";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import UserList from "@/components/user/UserList.vue";
import OrderList from "@/components/order/OrderList.vue";

@Component({
	components: {OrderList, UserList, AsiContentContainer}
})
export default class CompanyTabOrders extends Vue {

	@Prop({type: Object, required: true})
	public company!: Company;

}
